import { useState } from "react";
import "./index.css";

import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Products } from "./components/Products";
import { Pillars } from "./components/Pillars";
import { Process } from "./components/Process";
import { Contact } from "./components/Contact";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
import type { Page } from "./types";

export function App() {
  const [page, setPage] = useState<Page>("home");

  const navigate = (p: Page) => {
    setPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Navbar onNavigate={navigate} />
      {page === "contact" ? (
        <main>
          <ContactForm onNavigate={navigate} />
        </main>
      ) : (
        <main>
          <Hero onNavigate={navigate} />
          <Services />
          <Products />
          <Pillars />
          <Process />
          <Contact onNavigate={navigate} />
        </main>
      )}
      <Footer />
    </>
  );
}

export default App;
